import { User } from '../auth0/User';
import { AppState } from '../reducers/root.reducer';

export const getUserInfo = (state: AppState): User | undefined => state.authData?.user || undefined;
